import { render, staticRenderFns } from "./RegistPurchaseList.vue?vue&type=template&id=88ca16d0&scoped=true&"
import script from "./RegistPurchaseList.vue?vue&type=script&lang=js&"
export * from "./RegistPurchaseList.vue?vue&type=script&lang=js&"
import style0 from "./RegistPurchaseList.vue?vue&type=style&index=0&id=88ca16d0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "88ca16d0",
  null
  
)

export default component.exports